<template>
  <div class="settle-accounts-info">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="SurchargeRowInfo"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        @edit-actived="editActivedEvent"
        height="300"
      >
        <!-- :checkbox-config="{ checkMethod: activeRowMethod }" -->
        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增行</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.editRender.name == 'expenseType'">{{
              serviceExpenseList?.find((item) => item.value == row['expenseType'])?.label
            }}</span>

            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 费用类型 -->
            <el-select
              v-if="item.editRender.name == 'expenseType'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of serviceExpenseList"
                :key="index"
                :value="item.value"
                :label="item.label"
                :disabled="item.disabled"
              ></el-option>
            </el-select>

            <!-- 结算单价(含税) -->
            <input-number-ad
              :precision="2"
              :min="-99999"
              :max="99999999"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></input-number-ad>
            <!-- 结算数量 -->
            <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'statementQuantity'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>

            <!-- 结算金额(含税) -->
            <!-- <el-input-number
              :precision="2"
              :controls="false"
              :min="null"
              disabled
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              @input="(e) => handleChange(row, item.field)"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  // import BASEAPI from '@/api/dataBase.js';
  import expenseListMixin from '../../../../index.js';
  export default {
    mixins: [expenseListMixin],
    name: 'SettleAccountsInfo',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      expenseList: {
        type: Array,
        default: () => [],
      },
      selectInstructionDetailList: {
        type: Array,
        default: () => [],
      },
      currentSettleAccountRowData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        selectionList: [],
        tableData: [],
        tableRules,
        tableColumnList,
        deleteLineDetailIds: [], //删除明细行的ids
        // serviceExpenseList: JSON.parse(JSON.stringify(this.expenseList)),
        receiptMethod: null, //01付款  为负数   02收款  为正数
      };
    },
    computed: {
      expenseType() {
        return this.dictListMap?.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      serviceExpenseList() {
        return this.expenseList;
      },
    },
    methods: {
      updateExpenseList() {
        const $table = this.$refs.SurchargeRowInfo;
        // 获取表格中的全量数据
        const { fullData } = $table.getTableData();
        this.serviceExpenseList.forEach((item) => {
          if (item.value) {
            // 如果当前选项已经被选过，则禁用
            item.disabled = fullData.some((row) => {
              return row.expenseType == item.value;
            });
          }
        });
      },
      editActivedEvent({ row }) {
        console.log(row, 'row');
        // 激活编辑时检查剩余选项是否可选择
        this.updateExpenseList();
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.SurchargeRowInfo;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },

      // 新增行
      async newRowHandler() {
        // 先获取异常编号 和订单编号
        let { exceptionCode, remarks } = this.currentSettleAccountRowData;
        let {
          instructCode,
          // orderServiceType,
          orderCode,
          contractCode,
          customerName,
          customerNo,
          // productType,
          // productTypeName,
          // orderServiceTypeName,
          instructIssueDate,
          createdByName,
          createBy,
          projectCode,
          projectName,
          orderCompletedDate,
          // businessCompanyName,
          // businessCompanyNo,
          businessDepartmentName,
          businessDepartmentCode,
          platformCompanyNo,
          platformCompanyName,
        } = this.selectInstructionDetailList[0];
        this.insertEvent(
          {
            exceptionCode,
            orderCode,
            instructionNo: instructCode,
            businessDocCode: instructCode,
            // serviceType: orderServiceType,
            // productTypeName,
            // serviceTypeName: orderServiceTypeName,
            businessCategory: '02',
            // businessCompanyName: this.businessCompanyName,
            // businessCompanyNo: this.query.businessCompanyNo,
            // businessDepartmentName: this.businessDepartmentName,
            // businessDepartmentCode: this.query.businessDepartmentCode,
            businessCompanyName: platformCompanyName,
            businessCompanyNo: platformCompanyNo,
            businessDepartmentName,
            businessDepartmentCode,
            contractNo: contractCode,
            customerName,
            customerNo,
            // productType,
            accountPeriod: orderCompletedDate ? orderCompletedDate.slice(0, 7) : '',
            instructionIssueDate: instructIssueDate,
            salesmanName: createdByName,
            salesmanNo: createBy,
            abnormalExpenseFlag: '1',
            createMethod: '02',
            confirmStatus: '02',
            projectInitiationNo: projectCode,
            projectName,
            remark: remarks,
          },
          0
        );
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.SurchargeRowInfo;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
        console.log(this.getTableData(), 'getTableData()');
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = this.selectionList.map((item) => item._XID);
        this.selectionList.map((item) => this.deleteLineDetailIds.push(+item.id));
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
        this.$emit('deleteTableHandler', xIDList);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        if (field === 'expenseType') {
          this.updateExpenseList();
          let receiptMethod = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.receiptMethod;
          row['expenseTypeName'] = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.label;

          row['originalPrice'] =
            (['01'].includes(receiptMethod) ? '-' : '') +
            this.serviceExpenseList?.find((item) => item.value == row['expenseType'])
              ?.settleUnitPriceExcludeTax;
          row['statementQuantity'] = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.settleQty;
          row['originalAmount'] =
            (['01'].includes(receiptMethod) ? '-' : '') +
            this.serviceExpenseList?.find((item) => item.value == row['expenseType'])
              ?.settleAmoutExcludeTax;
        } else if (field === 'originalPrice') {
          let receiptMethod = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.receiptMethod;
          row['originalPrice'] =
            (['01'].includes(receiptMethod) && row['originalPrice'] > 0 ? '-' : '') +
            row['originalPrice'];
          row['originalAmount'] =
            +(row['originalPrice'] * row['statementQuantity']).toFixed(2) || '';
        } else if (field === 'statementQuantity') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['statementQuantity']).toFixed(2) || '';
        }
      },

      async closeEditTableHandler() {
        const $table = this.$refs.SurchargeRowInfo;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件

          const tableData = this.getTableData();
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          await $table.clearActived();
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.SurchargeRowInfo;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },

    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .settle-accounts-info {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
